exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.hide-text{\n    overflow: initial !important;\n    height: auto !important;\n}\n.texto{\n  height: 151rem;\n  overflow: hidden;\n  transition:  height 4s;\n}\n.i { cursor: pointer;\n}\n.padding-text{\n  margin-top : 25px !important;\n  padding-top: -20px;\n}\n#masTexto {\n  width: 100%;\n  height: 4em;\n    color: #007D80;\n  font-family: \"Open Sans\";\n  font-size: 16px;\n  font-weight: bold;\n  letter-spacing: 0;\n  line-height: 24px;\n  text-align: center;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-1915efd8","scoped":false,"hasInlineConfig":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./resources/assets/js/components/proyectosArea.vue
// module id = pasd
// module chunks = 0